// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RIrtuRwyw_3SjB {
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
}
.NWMYvQGQlejEQA {
  display: flex;
  justify-content: center;
}
.e6uWb3yIozGbCj {
  flex: 1 1 auto;
  min-height: calc(100vh - 80px);
  padding-bottom: 32px;
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
}
.aUXBlnaEMIjj2L {
  display: flex;
  justify-content: center;
  padding: 32px;
}
.sbQPQxTQBmzsRp {
  font-style: italic;
}
.wYp_PW126NZCZS {
  flex-grow: 1;
  min-width: 320px;
  max-width: 800px;
  padding: 32px;
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: 4px;
  background-color: var(--ds-surface, #ffffff);
}
.UUctmcUtiu80br {
  display: flex;
  align-items: center;
  justify-content: center;
}
.OkqDMGxagQELy8 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--ds-border, #091e4224);
}
.OkqDMGxagQELy8 .NiEfeHdnAWYZQh {
  margin: 12px 0 0;
}
.KyrJBWiro9gMgC {
  padding-top: 16px;
  border-top: 1px solid var(--ds-border, #091e4224);
}
.KyrJBWiro9gMgC button {
  margin-left: 8px;
}
.wnMGYZn7_WA_4k {
  display: flex;
  justify-content: flex-end;
}
@media only screen and (max-width: 900px) {
  .wYp_PW126NZCZS {
    padding: 16px;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flexRowWrap": `RIrtuRwyw_3SjB`,
	"flexAndCenter": `NWMYvQGQlejEQA`,
	"body": `e6uWb3yIozGbCj`,
	"navigationAndContent": `aUXBlnaEMIjj2L`,
	"learnMoreSubtle": `sbQPQxTQBmzsRp`,
	"content": `wYp_PW126NZCZS`,
	"spinnerContainer": `UUctmcUtiu80br`,
	"header": `OkqDMGxagQELy8`,
	"title": `NiEfeHdnAWYZQh`,
	"footer": `KyrJBWiro9gMgC`,
	"formFooter": `wnMGYZn7_WA_4k`
};
export default ___CSS_LOADER_EXPORT___;
